import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  app_Setting: any;
  constructor(private http: HttpClient) { }
  loadAppConfig() {
    return this.http.get('./assets/config/iPOSPOS_Config.json').pipe(map((response: any) => {
      return response
    })).toPromise().then(data => {
      this.app_Setting = data;
    });
  }
}
